import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2 } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function OrderReceipt() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then(({data}) => setOrder(data)).catch(() => {}); }, [id]);
  if (!order) return <div className="p-10 text-center">Loading...</div>;
  return (
    <div className="max-w-2xl mx-auto px-4 py-12" data-testid="order-receipt">
      <div className="mart-card p-8 text-center">
        <CheckCircle2 className="w-14 h-14 text-[#2C4A3B] mx-auto mb-3"/>
        <h1 className="font-heading text-3xl text-[#1A2421]">Order Confirmed</h1>
        <div className="font-accent text-xs text-[#D4AF37] mt-1">{order.order_number}</div>
        <p className="text-[#5C6B64] mt-3">Maraming salamat! We're preparing your order.</p>
      </div>
      <div className="mart-card p-6 mt-4">
        <h3 className="font-heading text-xl mb-3">Items</h3>
        <div className="space-y-2 text-sm">
          {order.items.map((it, idx) => (
            <div key={idx} className="flex justify-between">
              <span>{it.name} × {it.quantity}</span>
              <span>${(it.unit_price * it.quantity).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <hr className="my-4 border-[#8A9A86]/30"/>
        <div className="space-y-1 text-sm">
          <div className="flex justify-between"><span>Subtotal</span><span>${order.subtotal.toFixed(2)}</span></div>
          {order.discount > 0 && <div className="flex justify-between text-green-700"><span>Discount</span><span>-${order.discount.toFixed(2)}</span></div>}
          <div className="flex justify-between"><span>Tax</span><span>${order.tax.toFixed(2)}</span></div>
          <div className="flex justify-between font-heading text-xl text-[#2C4A3B] border-t pt-2 border-[#8A9A86]/30"><span>Total</span><span>${order.total.toFixed(2)}</span></div>
        </div>
        <div className="bg-[#0A1D42] text-[#D4AF37] p-3 rounded mt-4 text-center text-xs font-accent">
          <BrandLogo type="receipt" size="xs" showText={false} className="inline-flex mr-1" />You earned {order.points_earned} Royal Reward points
        </div>
      </div>
      <Link to="/" className="btn-mart w-full block text-center mt-6">Back to home</Link>
    </div>
  );
}
